import { useState } from 'react';

const navLinks = [
  { label: '精选直达', href: '#hero' },
  { label: '话题墙', href: '#wall' },
  { label: '分区导航', href: '#board' },
  { label: '实时热榜', href: '#hot' },
  { label: '评论区', href: '#discuss' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-amber-100 bg-[#fffaf3]/85 backdrop-blur-md">
      <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-4 py-3 md:px-6">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-white">
            <i className="ri-radar-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-black tracking-tight text-orange-700">看料</span>
            <span className="mt-1 text-[10px] font-medium tracking-wide text-stone-400">网址导航 · 持续收录</span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-stone-500 transition-colors hover:text-orange-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-orange-500 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600"
          >
            <i className={`ri-${copied ? 'checkbox-line' : 'star-line'} text-base`} />
            <span>{copied ? '已复制地址' : '收藏本站'}</span>
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-amber-200 text-orange-600 md:hidden"
            aria-label="菜单"
          >
            <i className={`ri-${open ? 'close-line' : 'menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="grid gap-1 border-t border-amber-100 bg-[#fffaf3] px-4 py-3 md:hidden">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="rounded-md px-2 py-2 text-sm font-medium text-stone-600 hover:bg-amber-50 hover:text-orange-600"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}